<template>
  <div class="payload-text" :class="isMe() ? 'me' : 'other'">
    <table>
      <tr v-if="isMe()">
        <td>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
          <span class="message" v-html="title"></span>
        </td>
      </tr>
      <tr v-else>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <span class="message" v-html="title"> </span>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PayloadText',
  props: {
    conversation: Object
  },
  data() {
    return {
      title: ''
    }
  },
  created() {
    this.title = this.conversation.message.payload.title
    if (this.conversation.message.payload.message) {
      const message = JSON.parse(this.conversation.message.payload.message)

      if (message.title) this.title = message.title
    }
  },
  methods: {
    isMe() {
      return this.conversation.sender === 'customer'
    }
  }
}
</script>
